import { useEffect, useState } from 'react';
import { useGoodsLikeRecommend } from '../queries/useGoodsLikeRecommend';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogDisplayCarousel = () => {
  const { data: goodsLikeRecommend, isSuccess } = useGoodsLikeRecommend();
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();
  const [logged, setLogged] = useState(false);

  useEffect(() => {
    if (logged) return;

    if (isSuccess) {
      goodsLikeRecommend.carousels.forEach(item => {
        logGoodsAnalytics({
          name: 'DISPLAY_CAROUSEL',
          analytics: {
            LIST_ID: item.item_list[0].logging.analytics.LIST_ID,
          },
        });
      });
      setLogged(true);
    }
  }, [goodsLikeRecommend.carousels, isSuccess, logGoodsAnalytics, logged]);
};
